(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("notificationUnsubscribe", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/public/notificationUnsubscribeView.html",
            controller: ["$stateParams", "publicResource", "messageService", NotificationUnsubscribeCtrl],
            controllerAs: "vm"
        };
        function NotificationUnsubscribeCtrl($stateParams, publicResource, messageService) {
            var vm = this;
            vm.showForm = true;
            vm.template = $stateParams.template;
            vm.showErrors = false;
            vm.formData = {
                user: $stateParams["u"].replace(/ /g, "+"),
                notificationTemplate: $stateParams.template
            };
            vm.unsub = unsub;
            function unsub() {
                publicResource.notificationUnsubscribe(vm.formData, function () {
                    vm.showSuccess = true;
                    vm.showForm = false;
                    vm.showErrors = false;
                }, function (error) {
                    messageService.error(error);
                    vm.showErrors = true;
                });
            }
        }
    });
}());
